export default __webpack_public_path__ + "static/media/the_pope_video_zh.551e1fad.svg";